import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "poi",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "ProgrammeOfInquiry" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [],
});
